import { c as _c } from "react/compiler-runtime";
import { hasB2BAction } from "./helpers";
import { useProfile } from "./request";
import { useJwtToken } from "./utils";
export function useHasB2BAction(actions) {
  const $ = _c(4);
  const {
    profileType
  } = useJwtToken();
  const {
    data: profile
  } = useProfile();
  let t0;
  if ($[0] !== actions || $[1] !== profile || $[2] !== profileType) {
    t0 = hasB2BAction(profileType, profile, actions);
    $[0] = actions;
    $[1] = profile;
    $[2] = profileType;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}